import React from 'react';
import palette from '../styles/palette';

const TruckIcon = ({
  width = '24px',
  height = '24px',
  stroke = palette.dpdRed,
  fill = 'none',
  strokeWidth = '5',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    strokeWidth={strokeWidth}
    stroke={stroke}
    fill={fill}
  >
    <path d="M19.55,43.93H38.1a2,2,0,0,0,2-2V16.28a2,2,0,0,0-2-2H8.68a2,2,0,0,0-2,2V41.91a2,2,0,0,0,2,2h2.6" />
    <path d="M44.33,43.93H40.19V23.23H50a1,1,0,0,1,.76.35l6.3,7.55a1,1,0,0,1,.23.64V43.93H53" />
    <ellipse cx="15.53" cy="45.23" rx="4.44" ry="4.5" />
    <ellipse cx="48.58" cy="45.23" rx="4.44" ry="4.5" />
  </svg>
);

const DriverLocationPin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 32"
    width="24"
    height="32"
  >
    <path
      d="m12,0.96c-6.31,0 -11.43,5.12 -11.43,11.43c0,6.67 9.52,17.14 10.48,18.1c0.57,0.57 1.33,0.57 1.9,0c0.95,-0.95 10.48,-11.43 10.48,-18.1c0,-6.31 -5.12,-11.43 -11.43,-11.43z"
      fill={palette.white}
      stroke={palette.dpdRed}
      strokeWidth="2"
    />
    <g transform="translate(4, 5)">
      <TruckIcon width={'17px'} height={'17px'} />
    </g>
  </svg>
);

export default DriverLocationPin;
